(function(){
  var hero = document.querySelector('.agency-collection-hero');
  if (!hero) return;

  var canvas = document.createElement('canvas');
  canvas.className = 'ach-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:1;';
  hero.style.position = 'relative';
  hero.style.overflow = 'hidden';
  hero.insertBefore(canvas, hero.firstChild);

  var pw = hero.querySelector('.page-width');
  if (pw) pw.style.cssText = 'position:relative;z-index:2;';

  var ctx = canvas.getContext('2d');
  var w, h, particles = [];

  // Neo Brutalism orange + navy
  var COLORS = [
    { r: 255, g: 92, b: 0 },    // accent orange
    { r: 27, g: 31, b: 59 },    // navy
    { r: 255, g: 120, b: 40 },  // light orange
    { r: 27, g: 31, b: 59 },    // navy
    { r: 251, g: 191, b: 36 },  // yellow accent
  ];

  var mouse = { x: -9999, y: -9999, active: false };
  var MOUSE_RADIUS = 200;
  var MOUSE_FORCE = 10;

  hero.style.pointerEvents = 'auto';
  hero.addEventListener('mousemove', function(e) {
    var rect = canvas.getBoundingClientRect();
    mouse.x = e.clientX - rect.left;
    mouse.y = e.clientY - rect.top;
    mouse.active = true;
  });
  hero.addEventListener('mouseleave', function() {
    mouse.active = false;
  });

  function resize() {
    w = canvas.width = hero.offsetWidth;
    h = canvas.height = hero.offsetHeight;
  }

  // Shape types: 0=dot, 1=hexagon, 2=plus, 3=diamond, 4=ring
  var SHAPE_COUNT = 5;

  function drawDot(sz) {
    ctx.beginPath();
    ctx.arc(0, 0, sz * 0.25, 0, Math.PI * 2);
    ctx.fill();
    // glow ring
    ctx.beginPath();
    ctx.arc(0, 0, sz * 0.4, 0, Math.PI * 2);
    ctx.stroke();
  }

  function drawHexagon(sz) {
    var s = sz * 0.4;
    ctx.beginPath();
    for (var i = 0; i < 6; i++) {
      var a = Math.PI / 3 * i - Math.PI / 6;
      var method = i === 0 ? 'moveTo' : 'lineTo';
      ctx[method](Math.cos(a) * s, Math.sin(a) * s);
    }
    ctx.closePath();
    ctx.stroke();
  }

  function drawPlus(sz) {
    var s = sz * 0.35;
    var t = s * 0.25;
    ctx.beginPath();
    ctx.moveTo(-t, -s); ctx.lineTo(t, -s);
    ctx.lineTo(t, -t); ctx.lineTo(s, -t);
    ctx.lineTo(s, t); ctx.lineTo(t, t);
    ctx.lineTo(t, s); ctx.lineTo(-t, s);
    ctx.lineTo(-t, t); ctx.lineTo(-s, t);
    ctx.lineTo(-s, -t); ctx.lineTo(-t, -t);
    ctx.closePath();
    ctx.stroke();
  }

  function drawDiamond(sz) {
    var s = sz * 0.4;
    ctx.beginPath();
    ctx.moveTo(0, -s);
    ctx.lineTo(s * 0.65, 0);
    ctx.lineTo(0, s);
    ctx.lineTo(-s * 0.65, 0);
    ctx.closePath();
    ctx.stroke();
  }

  function drawRing(sz) {
    ctx.beginPath();
    ctx.arc(0, 0, sz * 0.35, 0, Math.PI * 2);
    ctx.stroke();
    // inner dot
    ctx.beginPath();
    ctx.arc(0, 0, sz * 0.08, 0, Math.PI * 2);
    ctx.fill();
  }

  var drawFns = [drawDot, drawHexagon, drawPlus, drawDiamond, drawRing];

  function P() { this.r(); }
  P.prototype.r = function() {
    this.x = Math.random() * w;
    this.y = Math.random() * h;
    this.z = Math.random() * 500 + 150;
    this.vx = (Math.random() - 0.5) * 0.3;
    this.vy = (Math.random() - 0.5) * 0.2;
    this.vz = (Math.random() - 0.5) * 0.3;
    this.col = COLORS[Math.floor(Math.random() * COLORS.length)];
    this.s = Math.floor(Math.random() * SHAPE_COUNT);
    this.a = Math.random() * Math.PI * 2;
    this.rs = (Math.random() - 0.5) * 0.012;
  };

  P.prototype.u = function() {
    this.x += this.vx;
    this.y += this.vy;
    this.z += this.vz;
    this.a += this.rs;

    if (mouse.active) {
      var sc = 350 / this.z;
      var sx = (this.x - w / 2) * sc + w / 2;
      var sy = (this.y - h / 2) * sc + h / 2;
      var dx = sx - mouse.x;
      var dy = sy - mouse.y;
      var dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < MOUSE_RADIUS && dist > 0) {
        var force = (1 - dist / MOUSE_RADIUS) * MOUSE_FORCE / sc;
        var angle = Math.atan2(dy, dx);
        this.vx += Math.cos(angle) * force * 0.06;
        this.vy += Math.sin(angle) * force * 0.06;
        this.rs += (Math.random() - 0.5) * 0.008;
      }
    }

    this.vx *= 0.988;
    this.vy *= 0.988;
    this.vx += (Math.random() - 0.5) * 0.015;
    this.vy += (Math.random() - 0.5) * 0.012;

    if (this.z < 80 || this.z > 700) this.vz *= -1;
    if (this.x < -60) this.x = w + 60;
    if (this.x > w + 60) this.x = -60;
    if (this.y < -60) this.y = h + 60;
    if (this.y > h + 60) this.y = -60;
  };

  P.prototype.d = function() {
    var sc = 350 / this.z;
    var sx = (this.x - w / 2) * sc + w / 2;
    var sy = (this.y - h / 2) * sc + h / 2;
    var sz = Math.max(5, 32 * sc);
    var al = Math.min(0.6, 0.75 * sc);
    var c = this.col;
    var rgba = 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + al + ')';
    var rgbaFill = 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + (al * 0.5) + ')';

    ctx.save();
    ctx.translate(sx, sy);
    ctx.rotate(this.a);
    ctx.strokeStyle = rgba;
    ctx.fillStyle = rgbaFill;
    ctx.lineWidth = Math.max(0.6, 1.2 * sc);
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    drawFns[this.s](sz);

    ctx.restore();
    return { x: sx, y: sy, sc: sc, col: c, al: al };
  };

  function init() {
    resize();
    particles = [];
    var n = Math.min(50, Math.floor(w * h / 16000));
    for (var i = 0; i < n; i++) particles.push(new P());
  }

  function lines(pts) {
    for (var i = 0; i < pts.length; i++) {
      for (var j = i + 1; j < pts.length; j++) {
        var dx = pts[i].x - pts[j].x;
        var dy = pts[i].y - pts[j].y;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d < 180) {
          var al = (1 - d / 180) * 0.15;
          ctx.strokeStyle = 'rgba(27,31,59,' + al + ')';
          ctx.lineWidth = 0.5;
          ctx.beginPath();
          ctx.moveTo(pts[i].x, pts[i].y);
          ctx.lineTo(pts[j].x, pts[j].y);
          ctx.stroke();
        }
      }
    }
  }

  function mouseLines(pts) {
    if (!mouse.active) return;
    for (var i = 0; i < pts.length; i++) {
      var dx = pts[i].x - mouse.x;
      var dy = pts[i].y - mouse.y;
      var d = Math.sqrt(dx * dx + dy * dy);
      if (d < MOUSE_RADIUS) {
        var al = (1 - d / MOUSE_RADIUS) * 0.35;
        ctx.strokeStyle = 'rgba(27,31,59,' + al + ')';
        ctx.lineWidth = 0.8;
        ctx.beginPath();
        ctx.moveTo(mouse.x, mouse.y);
        ctx.lineTo(pts[i].x, pts[i].y);
        ctx.stroke();
      }
    }
    // cursor glow dot
    ctx.beginPath();
    ctx.arc(mouse.x, mouse.y, 3, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(27,31,59,0.5)';
    ctx.fill();
  }

  function loop() {
    ctx.clearRect(0, 0, w, h);
    var pts = [];
    for (var i = 0; i < particles.length; i++) {
      particles[i].u();
      pts.push(particles[i].d());
    }
    lines(pts);
    mouseLines(pts);
    requestAnimationFrame(loop);
  }

  window.addEventListener('resize', resize);

  if (window.innerWidth > 749) {
    init();
    loop();
  }
})();
